import React, { useState } from "react";
import Socket from "socket";
import { connect } from "react-redux";
import _ from "lodash";
import { Document, Page, pdfjs } from "react-pdf";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Pdf = (props) => {
  const room_data = _.get(props, "gameReducer.roomObj");
  const slidekick_url = _.get(room_data, "game_state.slidekick_url");
  const current_slide = _.get(room_data, "game_state.current_slide");

  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handle_feedback = (feedback) => {
    const userId = _.get(props, "gameReducer.currentUser.userId");
    const roomId = _.get(room_data, "id");
    const data = {
      action: "submit-feedback",
      roomId,
      userId,
      currentSlide: current_slide,
      feedback,
    };
    Socket.sendMessage(data);
  };

  return (
    <div className="slideKick-viewer-container">
      <div className="image-container">
        <TransformWrapper>
          <TransformComponent>
            <Document file={slidekick_url} onLoadSuccess={onDocumentLoadSuccess}>
              <Page pageNumber={current_slide} />
            </Document>
          </TransformComponent>
        </TransformWrapper>
      </div>
      <div className="btn-container">
        <button className="btn btn-unlike" onClick={() => handle_feedback("negative")}>
          <i className="fal fa-thumbs-down fa-2x"></i>
        </button>
        <button className="btn btn-like" onClick={() => handle_feedback("positive")}>
          <i className="fal fa-thumbs-up fa-2x"></i>
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Pdf);
